import { Box, Grid, GridItem, position } from "@chakra-ui/react";
import JackpotItem from "./components/JackpotItem";
import useIsLandScapeMachine from "../../hook/useIsLandScapeMachine";
import useJackpotQueries from "./hooks/useJackpotQueries";
import { useEffect, useState } from "react";
import { getJackpotList } from "../../api/getApi";

const JackpotList = ({ fixed }) => {
  const [trigger, setTrigger] = useState(0);

  const fixedStyle = fixed
    ? {
        width: "-webkit-fill-available",
        bottom: "0px",
        position: "fixed",
      }
    : {};

  const isLandScapeMachine = useIsLandScapeMachine();

  const { jackpotList } = useJackpotQueries();

  const jackpotListToArray = Object.values(jackpotList || {});

  // 每分鐘更新一次 trigger 以觸發動畫
  useEffect(() => {
    const interval = setInterval(() => {
      setTrigger((prev) => prev + 1);
    }, 15000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Grid
      {...fixedStyle}
      display={{
        base: isLandScapeMachine ? "grid" : "none",
        md: "grid",
      }}
      templateColumns="repeat(5, 1fr)"
    >
      <GridItem>
        <JackpotItem
          jackpotValue={jackpotListToArray[0]}
          type="Grand"
          trigger={trigger}
        />
      </GridItem>
      <GridItem>
        <JackpotItem
          jackpotValue={jackpotListToArray[1]}
          type="Major"
          trigger={trigger}
        />
      </GridItem>
      <GridItem>
        <JackpotItem
          jackpotValue={jackpotListToArray[2]}
          type="Mega"
          trigger={trigger}
        />
      </GridItem>
      <GridItem>
        <JackpotItem
          jackpotValue={jackpotListToArray[3]}
          type="Mini"
          trigger={trigger}
        />
      </GridItem>
      <GridItem>
        <JackpotItem
          jackpotValue={jackpotListToArray[4]}
          type="Minor"
          trigger={trigger}
        />
      </GridItem>
    </Grid>
  );
};

export default JackpotList;
